let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kfTIE")).then(() => parcelRequire('e3XiS'));